<template>
    <div id="dmh">
        <div class="page-header">
            <div class="content-container row">
                <div class="page-title col-md-12 col-lg-6">
                    <h2>Your <span class="brand-primary">Mental Health</span> Matters</h2>
                    <p class="pb-5">Our mission is to ensure you have access to holistic care that addresses every aspect of your health
                        journey. With us, you're not alone – we're here to support you every step of the way.</p>
                    <p class="pb-5">We offer unlimited access for you and your family,
                        to a telephone helpline, available 24 hours a day,
                        7 days a week, 365 days a year</p>
                    <b-button class="py-4 px-5 d-flex align-items-center" variant="cta" size="lg" @click="$router.push('/')">Get Support Now <i
                            class="fa-regular fa-circle-arrow-right ml-3"></i></b-button>
                </div>
                <div class="call-us col-md-12 col-lg-6 d-flex align-items-center">
                    <div class="video-wrap ml-3">
                        <video width="100%" class="video" controls controlsList="nodownload"
                            :poster="'/img/eap/EAP-placeholder.png'">
                            <source :src="pageData.defaults.video_url" />
                        </video>
                    </div>
                </div>
            </div>
        </div>
        <div class="phone-row row">
            <div class="content-container">
                <h2>Call us <span class="brand-primary">Anytime,</span> Anywhere</h2>
                <div class="row col-12">
                    <div class="col-md-6 col-sm-12 phone-item">
                        <div>UK:<br/><a class="phone-link brand-primary">0808 196 2016</a></div>
                    </div>
                    <div class="col-md-6 col-sm-12 phone-item">
                        <div>International:<br/><a class="phone-link brand-primary">00353 1 518 0277</a></div>
                    </div>
                    <div class="col-md-6 col-sm-12 phone-item">
                        <div>WhatsApp / SMS:<br/><a class="phone-link brand-primary">00353 87 369 0010</a></div>
                    </div>
                    <div class="col-md-6 col-sm-12 phone-item">
                        <div>UK WHatsApp / SMS:<br/><a class="phone-link brand-primary">+44 7418 360 780</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-column bg-white">
            <div class=" py-5 mt-5 px-md-5 d-none d-lg-flex" v-if="pageData.defaults &&
                pageData.services_support &&
                pageData.services_support.active &&
                hasServices
                ">
                <div class="content-container row support justify-content-center">
                    <div class="section-header pb-5">
                        <h2 class="section-header-title">Our Support Services</h2>
                    </div>
                    <div v-for="serviceCard in pageData.services_support.items" v-if="serviceCard.active"
                        class="eap-service-card col-md-5ths px-5 flex-grow-1">
                        <div class="service-card-img-container">
                            <img class="service-card-img" :src="serviceCard.img_url" />
                        </div>
                        <div class="service-card-description bran" v-html="serviceCard.title">
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
  
<script>
// @ is an alias to /src
import axios from "axios";
import config from "../config/constants";
import BookingCard from "../components/DMH/Booking/BookingCard.vue";
import EventBus from "@/helpers/eventbus" 

export default {
    name: "eap",
    components: {
        BookingCard
    },
    data() {
        return {
            bookings: [],
            callbackSelected: false,
            selectedService: '',
            phoneNumber: '',
            accessCodeEmail: '',
            accessCodeName: '',
            callBackSuccess: false,
            pageData: {
                defaults: {
                    eap_title: 'EAP',
                    live_chat: true
                }
            },
            articles: [],
            img_type: {
                video: "video-white.svg",
                text: "blog-white.svg",
                image: "far fa-image",
                audio: "podcast-white.svg"
            },
            contentLoading: true,
            landg_eap: false,
        };
    },
    mounted() {
        this.getEapContent();
        this.getResourceList();
        EventBus.$emit('updateNav', 'home');

        const vm = this
        // window.addEventListener("load", function(){
        //   if(window.$zopim) {
        //     window.$zopim.livechat.setLanguage(vm.$store.state.lang)
        //     window.$zopim.livechat.setGreetings({
        //       'online': vm.componentText.zendeskTitle,
        //     })
        //     window.$zopim.livechat.window.setTitle(vm.componentText.zendeskTitle)
        //     window.$zopim.livechat.prechatForm.setGreetings(vm.componentText.zendeskIntro)
        //   }
        // });
        if (this.$route.query.callback) {
            this.callbackSelected = true;
        }
    },
    destroyed() {
        let sf = document.getElementById('live-chat-widget');
        sf.style.display = "none";
        //remove zendesk
        // if(window.$zopim) {
        //   window.$zopim.livechat.hideAll()
        // }
    },
    methods: {

        async getEapContent() {
            const payload = {
                user_id: this.$store.getters.user_id
            }
            let res = await axios.post(config.api_env + '/application/api/u/customisations/get-eap-content', payload, config.options)
            if (res.data.success) {
                this.pageData = res.data.eap_customisation
                this.landg_eap = res.data.landg_eap
                this.contentLoading = false
            }

        },
        async getResourceList() {
            const payload = {
                user_id: this.$store.getters.user_id,
                "search_key": "",
                "filter": "",
                "tag": "mind",
                "fav_only": "0",
                "page": "0",
                "page_size": "4",
                "surge_only": 1
            }
            let res = await axios.post(config.api_env + '/application/api-hc/get-all-resource-list', payload, config.options)
            if (res.data.success) {
                this.articles = res.data.resources
            }

        },
        getEAPServicesImage() {
            if (this.$store.getters.skin === 0) {
                return '';
            } else if (this.$store.getters.skin === 10) {
                return '-laya'
            }
            return '-generic';
        },


    },
    computed: {
        componentText() {
            return this.getText.loggedIn.eap;
        },
        skin() {
            return this.$store.getters.skin;
        },
        services() {
            return [
                {
                    id: 0,
                    name: this.componentText.mentalWellbeing,
                    content: this.componentText.mentalWellbeingContent
                },
                {
                    id: 1,
                    name: this.componentText.finance,
                    content: this.componentText.financeContent
                },
                {
                    id: 2,
                    name: this.componentText.life,
                    content: this.componentText.lifeContent
                },
                {
                    id: 3,
                    name: this.componentText.career,
                    content:
                        this.componentText.careerContent1 +
                        this.pageData.defaults.eap_title +
                        this.componentText.careerContent2
                },
                {
                    id: 4,
                    name: this.componentText.consumer,
                    content:
                        this.componentText.consumerContent1 +
                        this.pageData.defaults.eap_title +
                        this.componentText.consumerContent2
                },
                {
                    id: 5,
                    name: this.componentText.mediation,
                    content: this.componentText.mediationContent
                },
                {
                    id: 6,
                    name: this.componentText.nonNationals,
                    content: this.componentText.nonNationalsContent
                },
                {
                    id: 7,
                    name: this.componentText.legal,
                    content:
                        this.componentText.legalContent1 +
                        this.pageData.defaults.eap_title +
                        this.componentText.legalContent2
                },
                {
                    id: 8,
                    name: this.componentText.medical,
                    content:
                        this.componentText.medicalContent
                }
            ];
        },
        filteredServices() {
            let services = []
            for (let i = 0; i < this.pageData.services_offered.items.length; i++) {
                if (this.pageData.services_offered.items[i].active) {
                    services.push(this.services[i])
                }
            }
            return services
        },
        hasServices() {
            let hasServices = false;
            for (let i = 0; i < this.pageData.services_support.items.length; i++) {
                if (this.pageData.services_support.items[i].active) {
                    hasServices = true
                }
            }
            return hasServices
        },
    },
};
</script>
<style lang="less">
#dmh {
    .page-header {
        display: flex;
        align-items: center;
        background-image: url('/img/dmh/dmhheader.svg');
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: right;
        padding: 60px 0;
        color: black;
        min-height: 700px;
        .fa-circle-arrow-right{
            font-size: 2.4rem;
        }
        .page-title {
            text-align: left;

            h2 {
                text-align: left;
                font-size: 3.8rem;
                letter-spacing: 0;
                font-family: "PlusJakartaSansBold";
            }

            p {
                font-size: 2rem;
                font-family: "PlusJakartaSansRegular";
            }
        }

        .call-us {
            text-align: right;

            img {
                max-width: 220px;
            }

            h3 {
                font-family: 'FilsonProLight';
                font-size: 3.2rem;
                letter-spacing: 0;
                font-weight: 100;
                padding-top: 20px;
            }

            .btn {
                font-size: 1.3rem;
                font-family: "PlusJakartaSansBold";
            }
        }

        .video-wrap {
            -o-object-fit: fill;
            object-fit: fill;

            .video {
                -o-object-fit: fill;
                object-fit: fill;

                &:focus {
                    outline: none;
                }
            }
        }

        .video-player {
            max-width: 550px;
            text-align: center;
            margin: auto;
        }
    }
    .phone-row{
        background-image: url('/img/dmh/worldmap.svg');
        padding: 100px 0;
        background-color: white;
        h2 {
            font-size: 3.2rem;
            letter-spacing: 0;
            font-family: "PlusJakartaSansBold";
        }
        .phone-item{
            padding: 50px;
            font-size: 2rem;
            text-align: center;
            display: flex;
            justify-content: center;
            font-family: "PlusJakartaSansBold";

            .phone-link{
                border-bottom: 3px solid;
                font-family: "PlusJakartaSansBold";

            }
        }
    }

    .services-offered {
        justify-content: center;
    }
    .section-header-title{
        font-size: 3.2rem;
        letter-spacing: 0;
        font-family: "PlusJakartaSansBold";
    }
    .eap-cards {
        .eap-card {
            .eap-card-img {
                border-radius: 50%;
                width: 100%;
                height: 100%;
                max-width: 100px;
            }

            .eap-card-content {
                font-family: FilsonProLight, sans-serif;
                font-size: 1.8rem;
                line-height: 2.3rem;
                letter-spacing: 0;

                @media (max-width: 992px) {
                    text-align: center;
                }
            }
        }
    }

    .eap-service-card {
        &:not(:last-of-type)::after {
            content: "";
            position: absolute;
            top: 70%;
            right: 0;
            width: 1px;
            height: 30%;
            transform: translateY(-50%);
            background: #cccccc;
        }

        .service-card-img-container {
            height: 90px;

            .service-card-img {
                height: 90px;
                transform: translateX(25%);
                width: 65%;
                z-index: 2;
            }
        }

        .service-card-description {
            font-family: "PlusJakartaSansRegular";
            margin-top: 20px;
            font-size: 1.8rem;
            line-height: 1.2;
            text-align: center;
            letter-spacing: 0;
        }
    }

    .support {
        padding-bottom: 80px;
    }

}</style>
  